import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getUserEmail } from "../../../utils/auth";
import BASE_URL from "../../../config/apiConfig";
import "./CropClinicSubscriptionList.css";

const CropClinicSubscriptionList = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Function to determine if subscription is expired
  const isExpired = (fields) => {
    const now = new Date();
    // If any field is still valid, it's not expired
    return fields.every((field) => new Date(field.expires_at) < now);
  };

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const email = getUserEmail();
        const response = await axios.post(
          `${BASE_URL}/api/payment/getTransactions`,
          { email }
        );
        setTransactions(response.data.transactions);
        setLoading(false);
      } catch (error) {
        setError("Failed to fetch subscriptions. Please try again later.");
        setLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  return (
    <div className="crop-subscription-page">
      <h1 className="crop-subscription-title">Crop Clinic</h1>

      {loading ? (
        <div className="crop-loading-container">
          <div className="crop-spinner"></div>
        </div>
      ) : error ? (
        <div className="crop-error-container">
          <p className="crop-error-message">{error}</p>
        </div>
      ) : transactions.length === 0 ? (
        <div className="crop-empty-container">
          <p className="crop-empty-message no-subscription-text">
            No farms available right now. Please add your farm to get started.
          </p>
          <button
            className="crop-add-farm-cta"
            onClick={() => navigate("/user/add-farm-now")}
          >
            Add New Farm
          </button>
        </div>
      ) : (
        <div className="crop-subscriptions-grid">
          {transactions.map((transaction) => {
            const expired = isExpired(transaction.fields);

            return (
              <div className="crop-subscription-card" key={transaction.id}>
                {transaction.fields.map((field, index) => (
                  <p key={index} className="crop-plan-name">
                    <strong>{field.field_name}</strong>
                  </p>
                ))}
                <p>
                  <strong className="sub-heading">Crop :</strong>{" "}
                  {transaction.crop_name}
                </p>
                <p>
                  <strong className="sub-heading">Remaining Units :</strong>{" "}
                  {transaction.crop_clinic} Hits
                </p>
                {transaction.fields.map((field, index) => (
                  <p key={index}>
                    <strong className="sub-heading">Expiry:</strong>{" "}
                    {new Date(field.expires_at).toLocaleDateString("en-US", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </p>
                ))}

                <div className="crop-button-container">
                  <button
                    className={`crop-add-farm-button ${
                      transaction.crop_clinic <= 0 || expired ? "expired" : ""
                    }`}
                    disabled={transaction.crop_clinic <= 0 || expired}
                    onClick={() =>
                      navigate(`/user/crop-clinic/${transaction.crop_name}`, {
                        state: {
                          id: transaction.id,
                          cropname: transaction.crop_name,
                          crop_clinic: transaction.crop_clinic,
                        },
                      })
                    }
                  >
                    {expired
                      ? "Expired"
                      : transaction.crop_clinic > 0
                        ? "Crop Clinic"
                        : "No Trials Left"}
                  </button>
                  <button
                    className="crop-history-button"
                    onClick={() =>
                      navigate(`/user/crop-clinic/history/${transaction.id}`, {
                        state: {
                          id: transaction.id,
                          cropname: transaction.crop_name,
                          crop_clinic: transaction.crop_clinic,
                        },
                      })
                    }
                  >
                    See History
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CropClinicSubscriptionList;
